import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTheme } from '../../theme/themeContext';
import classNames from 'classnames';

const Sidebar = ({ sidebarConfig = { title: 'Dashboard', menuItems: [] } }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { sidebarColor } = useTheme();
  const [expandedItems, setExpandedItems] = useState(new Set());

  const bgColors = {
    blue: 'bg-blue-600',
    green: 'bg-green-600',
    red: 'bg-red-600',
    purple: 'bg-purple-600'
  };

  const toggleExpand = (path) => {
    setExpandedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(path)) {
        newSet.delete(path);
      } else {
        newSet.add(path);
      }
      return newSet;
    });
  };

  const handleItemClick = (item) => {
    const hasSubItems = item.subItems && item.subItems.length > 0;
    
    if (hasSubItems) {
      toggleExpand(item.path);
    } else if (item.external) {
      // 外部リンクの場合は新しいタブで開く
      window.open(item.path, '_blank');
    } else {
      // 通常のメニュー項目の場合は通常の遷移
      navigate(item.path);
    }
  };

  const renderMenuItem = (item) => {
    const Icon = item.icon;
    const isExpanded = expandedItems.has(item.path);
    const hasSubItems = item.subItems && item.subItems.length > 0;

    return (
      <div key={item.path}>
        <div
          className={classNames(
            'flex items-center px-4 py-3 rounded-lg transition-colors cursor-pointer',
            'hover:bg-white hover:bg-opacity-10',
            location.pathname.includes(item.path) ? 'bg-white bg-opacity-10' : ''
          )}
          onClick={() => handleItemClick(item)}
        >
          <Icon className="w-6 h-6 mr-3" />
          <span>{item.name}</span>
          {hasSubItems && (
            <svg
              className={`w-4 h-4 ml-auto transform transition-transform ${isExpanded ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          )}
        </div>

        {/* サブメニュー */}
        {hasSubItems && isExpanded && (
          <div className="ml-6 mt-1">
            {item.subItems.map((subItem) => {
              const SubIcon = subItem.icon;
              return (
                <div
                  key={subItem.path}
                  className={classNames(
                    'flex items-center px-4 py-2 rounded-lg transition-colors cursor-pointer',
                    'hover:bg-white hover:bg-opacity-10',
                    location.pathname.includes(subItem.path) ? 'bg-white bg-opacity-10' : ''
                  )}
                  onClick={() => navigate(`${item.path}/${subItem.path}`)}
                >
                  <SubIcon className="w-5 h-5 mr-3" />
                  <span>{subItem.name}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className={`h-full ${bgColors[sidebarColor]} text-white`}>
      {/* ロゴ */}
      <div className="px-6 py-4 border-b border-opacity-20 border-white">
        <h1 className="text-xl font-bold">{sidebarConfig.title}</h1>
      </div>

      {/* ナビゲーション */}
      <nav className="mt-6 px-4">
        {sidebarConfig.menuItems.map(renderMenuItem)}
      </nav>
    </div>
  );
};

export default Sidebar;